import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { getProductDetails } from '../../redux/actions/productActions';
import ImageSection from './ImageSection';
import Detailsection from './Detailsection';

const ProductDetail = () => {
    const {id}=useParams();
    const dispatch=useDispatch();
    const {loading,product}=useSelector(state=>state.getProductDetails)
    console.log('loading');
    console.log(loading);
    console.log('product');
    console.log(product);
    useEffect(()=>{
      if(product && id !== product.id) 
        dispatch(getProductDetails(id));
    },[dispatch,product,id,loading])
  return (
    <>
      {
        product && Object.keys(product).length &&
        <div className='flex justify-center items-center space-x-[50px] my-[50px]'>
          <ImageSection product={product}/>
          <Detailsection product={product}/>
        </div>
      }
      
    </>
  )
}

export default ProductDetail
